module.exports = __webpack_public_path__ + "img/webinar-countdown-bg.5091788.webp";